export default {"src":"/_next/static/media/steel.73990985.svg","height":121,"width":121};